export default "__VITE_ASSET__D3IbA2kl__"